class IframeYoutube {
  constructor(el) {
    this.el = el;
    this.iframe = this.el.querySelector('iframe');
    this.icon = this.el.querySelector('.icon');
    this.image = this.el.querySelector('.image');

    if(this.image) {
      this.image.addEventListener('click', () => {
        this.image.style.display = 'none';
        this.icon.style.display = 'none';

        if (!(this.iframe instanceof HTMLIFrameElement)) return;

        // Forzar autoplay
        const url = new URL(this.iframe.src, window.location.href);
        if (!url.searchParams.get("autoplay")) {
          url.searchParams.set("autoplay", "1");
          this.iframe.src = url.toString();
        }
        
        this.iframe.style.display = 'block';
      });
    }

  }
}


const bannerVideo = document.querySelector('.banner-video');

if(bannerVideo) {
  new IframeYoutube(bannerVideo);
}